const state = {
    wireUseInformationFields: [
        {
            key: "index",
            label: "項次",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "code",
            label: "線材品號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "chinese_name",
            label: "線材品名",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "scroll_no",
            label: "線材捲號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "furnaceCode",
            label: "爐號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "start_weight",
            label: "起始重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "remain_weight",
            label: "剩餘重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "consumption",
            label: "耗用量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        // {
        //     key: "attrition",
        //     label: "超耗率(%)",
        //     sortable: false,
        //     class: "font-family-dfyuanstd-w5 table-col-hight"
        // }
    ],
    wireUseInformationItem: [],
}
const getters = {
    get_wireUseInformationFields: state => {
        return state.wireUseInformationFields
    },
    get_wireUseInformationItem: state => {
        return state.wireUseInformationItem
    },
}
const actions = {
    set_wireUseInformationFields(context, array) {
        context.commit('SET_WIREUSEINFORMATIONFIELDS', array);
    },
    set_wireUseInformationItem(context, array) {
        context.commit('SET_WIREUSEINFORMATIONITEM', array);
    },
    clear_wireUseInformationItem(context) {
        context.commit('CLEAR_WIREUSEINFORMATIONITEM');
    },
}
const mutations = {
    SET_WIREUSEINFORMATIONFIELDS(state, array) {
        state.wireUseInformationFields = array;
    },
    SET_WIREUSEINFORMATIONITEM(state, array) {
        state.wireUseInformationItem = array;
    },
    CLEAR_WIREUSEINFORMATIONITEM(state) {
        state.wireUseInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wireUseInformation.js